<ion-card mode="ios">
  <ion-card-content>
    <p class="pregunta">{{ pregunta.Descripcion }}</p>
    <hr class="separator" />
    <div
      class="icons"
      *ngFor="let face of facesIcons; let i = index"
      (click)="changeStatus(i)"
    >
      <img
        [ngClass]="{
          'icon-status': face.status,
          'icon-status-gray': !face.status
        }"
        [src]="face.source"
      />
    </div>
    <p class="pregunta">{{ pregunta.MejoraTitulo }}</p>
    <ion-textarea
      placeholder="Máximo 140 Caracteres"
      maxlength="140"
      mode="md"
      [(ngModel)]="preguntaAbierta"
    ></ion-textarea>
    <ion-button
      [disabled]="!opcionSeleccionada"
      class="button-next"
      color="tpcta"
      (click)="siguientePregunta()"
      >Siguiente</ion-button
    >
  </ion-card-content>
</ion-card>
